import { SStyled } from '../../../styles/theme'
import { mobileMaxWidth } from '../constants'
import Modal from 'react-modal'

export const ContentWrapper = SStyled(Modal)`
    width: 500px;
    max-height: 500px;
    min-height: auto;
    overflow: scroll;
    @media screen and (max-width: ${mobileMaxWidth}) {
        width: 80%;
        max-height: 500px;
    }
`
